var exports = {
  "K": "xcc377c0b--0f918c--icon",
  "w": "xcc377c0b--0f918c--logo",
};

module.exports = exports;
